(() => {

  function initGallery(gallery) {

    if (!gallery || gallery.dataset.lourdaneReady === 'true') {
      return;
    }

    const slides = Array.from(
      gallery.querySelectorAll('[data-gallery-slide]')
    );

    const dots = Array.from(
      gallery.querySelectorAll('[data-gallery-dot]')
    );

    const prevButton = gallery.querySelector('[data-gallery-prev]');
    const nextButton = gallery.querySelector('[data-gallery-next]');

    const productCard = gallery.parentElement;

    const productLink = productCard
      ? productCard.querySelector('a.stretched-link')
      : null;

    if (!slides.length) {
      return;
    }

    gallery.dataset.lourdaneReady = 'true';

    let currentIndex = 0;

    let startX = 0;
    let startY = 0;

    let currentX = 0;
    let currentY = 0;

    let pointerActive = false;


    /* ==========================================
       IMAGE DISPLAY
       ========================================== */

    function showSlide(index) {

      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      currentIndex = index;

      slides.forEach((slide, i) => {
        slide.classList.toggle(
          'is-active',
          i === currentIndex
        );
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle(
          'is-active',
          i === currentIndex
        );
      });

    }


    function nextSlide() {
      showSlide(currentIndex + 1);
    }


    function previousSlide() {
      showSlide(currentIndex - 1);
    }


    /* ==========================================
       DESKTOP ARROWS
       ========================================== */

    if (nextButton) {

      nextButton.addEventListener(
        'pointerdown',
        event => {

          event.preventDefault();
          event.stopPropagation();

        }
      );

      nextButton.addEventListener(
        'pointerup',
        event => {

          event.preventDefault();
          event.stopPropagation();

          nextSlide();

        }
      );

      nextButton.addEventListener(
        'click',
        event => {

          event.preventDefault();
          event.stopPropagation();

        }
      );

    }


    if (prevButton) {

      prevButton.addEventListener(
        'pointerdown',
        event => {

          event.preventDefault();
          event.stopPropagation();

        }
      );

      prevButton.addEventListener(
        'pointerup',
        event => {

          event.preventDefault();
          event.stopPropagation();

          previousSlide();

        }
      );

      prevButton.addEventListener(
        'click',
        event => {

          event.preventDefault();
          event.stopPropagation();

        }
      );

    }


    /* ==========================================
       TAP + SWIPE
       ========================================== */

    gallery.addEventListener(
      'pointerdown',
      event => {

        /*
         * Ignore arrow presses.
         */
        if (
          event.target.closest(
            '.lourdane-card-gallery__arrow'
          )
        ) {
          return;
        }

        pointerActive = true;

        startX = event.clientX;
        startY = event.clientY;

        currentX = startX;
        currentY = startY;

      }
    );


    gallery.addEventListener(
      'pointermove',
      event => {

        if (!pointerActive) {
          return;
        }

        currentX = event.clientX;
        currentY = event.clientY;

      }
    );


    gallery.addEventListener(
      'pointerup',
      event => {

        if (!pointerActive) {
          return;
        }

        pointerActive = false;

        currentX = event.clientX;
        currentY = event.clientY;

        const distanceX = currentX - startX;
        const distanceY = currentY - startY;

        const horizontalDistance = Math.abs(distanceX);
        const verticalDistance = Math.abs(distanceY);


        /* ======================================
           SWIPE
           ====================================== */

        if (
          horizontalDistance >= 35 &&
          horizontalDistance > verticalDistance
        ) {

          event.preventDefault();
          event.stopPropagation();

          /*
           * Swipe left
           */
          if (distanceX < 0) {
            nextSlide();
          }

          /*
           * Swipe right
           */
          else {
            previousSlide();
          }

          return;
        }


        /* ======================================
           NORMAL TAP / CLICK
           ====================================== */

        /*
         * Only open the product when there was
         * very little movement.
         *
         * This prevents normal vertical scrolling
         * from accidentally opening products.
         */
        if (
          horizontalDistance < 12 &&
          verticalDistance < 12
        ) {

          if (productLink) {

            const href = productLink.getAttribute('href');

            if (href) {

              event.preventDefault();
              event.stopPropagation();

              window.location.assign(href);

            }

          }

        }

      }
    );


    gallery.addEventListener(
      'pointercancel',
      () => {

        pointerActive = false;

      }
    );


    /*
     * Prevent the browser-generated click from
     * activating Galleria's stretched link after
     * we've already handled tap/swipe ourselves.
     */
    gallery.addEventListener(
      'click',
      event => {

        if (
          event.target.closest(
            '.lourdane-card-gallery__arrow'
          )
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

      },
      true
    );


    /* ==========================================
       INITIAL STATE
       ========================================== */

    showSlide(0);

  }



  /* ==========================================
     INITIALISE ALL PRODUCT GALLERIES
     ========================================== */

  function initAll(root = document) {

    root
      .querySelectorAll('[data-product-gallery]')
      .forEach(initGallery);

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAll();
      }
    );

  } else {

    initAll();

  }


  /* ==========================================
     SHOPIFY THEME EDITOR
     ========================================== */

  document.addEventListener(
    'shopify:section:load',
    event => {

      initAll(event.target);

    }
  );


  /* ==========================================
     AJAX FILTERS / DYNAMIC PRODUCT CARDS
     ========================================== */

  const observer = new MutationObserver(
    mutations => {

      mutations.forEach(mutation => {

        mutation.addedNodes.forEach(node => {

          if (!(node instanceof HTMLElement)) {
            return;
          }

          if (
            node.matches('[data-product-gallery]')
          ) {
            initGallery(node);
          }

          initAll(node);

        });

      });

    }
  );


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

})();